import {HttpErrorResponse} from '@angular/common/http';
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, SortDirection} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {
  FabDateFilterComponent,
  FabDateFilterOperator,
  FabNumberFilterComponent,
  FabStringFilterComponent,
  FabStringFilterOperator
} from '@fabric/components/table-filter';
import {FabTableState, filterStateChange, process} from '@fabric/components/table-filter/data-query';
import {catchError, EMPTY, concat, map, Observable, ObservableInput, startWith} from 'rxjs';
import {ErrorCodes} from '../../constants/ErrorCodes';
import {DispatchVehicleResults} from '../../models/DispatchVehicleResults';
import {ViewVehicle} from '../../models/ViewVehicle';
import {NotificationService} from '../../services/notification.service';
import {
  PopupCancelVehicleDialogComponent
} from '../../shared-components/popup-cancel-vehicle-dialog/popup-cancel-vehicle-dialog.component';
import {RemitoVehicleService} from "../../services/remito-vehicle.service";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {ViewVehicleSearch} from "../../models/ViewVehicleSearch";
import {SecurityService} from "../../services/security.service";
import {
  DestinatarioBriefModel,
  IdDescModel,
  RemitoVehicleCreationDetails,
  TransporteBriefModel
} from "../../models/RemitoVehicleCreationDetails";
import {
  PopupFileUploadMessageDialogComponent, SCREEN
} from "../../shared-components/popup-file-upload-message-dialog/popup-file-upload-message-dialog.component";

@Component({
  selector: 'app-view-vehicle-remitos',
  templateUrl: './view-vehicle-remitos.component.html',
  styleUrls: ['./view-vehicle-remitos.component.scss']
})
export class ViewVehicleRemitosComponent implements OnInit {
  user: string;

  displayedColumns: string[] = [
    'checkbox', 'remitoTypeField', 'clase', 'ptoEmision', 'nroRemito', 'descOrigen', 'nombreDestino',
    'nombreTransp', 'fecGen', 'fechaDeEnvio', 'estadoRemito', 'remitoButtons'
  ];
  dataSource: MatTableDataSource<ViewVehicle> = new MatTableDataSource<ViewVehicle>();
  searchDataSource: MatTableDataSource<RemitoVehicleCreationDetails> = new MatTableDataSource<RemitoVehicleCreationDetails>();
  createDetailsData: RemitoVehicleCreationDetails[] = [];
  remitos: ViewVehicle[] = [];
  impresoras: IdDescModel[] = [];
  impresorasMap: Map<string, IdDescModel> = new Map<string, IdDescModel>();
  impresoraRemito: ViewVehicle;
  operators: FabStringFilterOperator[] = ['contains'];
  selectedRemitos: ViewVehicle[] = [];
  errors: HttpErrorResponse[] = [];
  errorMessage: string = '';

  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };

  estadoList: Array<string> = [
    "Impreso",
    "Reimpreso",
    "Cancelado"
  ]

  disableEmailButton: boolean = false;
  disableEmailAllButton: boolean = true;
  isLoading: boolean = false;
  isDownloadingExcel: boolean = false;
  initialLoadingCompleted = false;
  showTabledata: boolean = false;

  // search form
  @ViewChild('formDirective') private formDirective: FormGroupDirective;
  viewVehicleSearch: ViewVehicleSearch;
  selectPtoEmision: string = "";
  selectDestinatario: string = "";
  selectOrigen: string = "";
  selectTransporte: string = "";
  selectFecGenDesde: Date | null = null;
  selectFecGenHasta: Date | null = null;
  selectDespachoDesde: Date | null = null;
  selectDespachoHasta: Date | null = null;

  ptoEmision: IdDescModel[] = [];
  transporte: TransporteBriefModel[] = [];
  destinatario: DestinatarioBriefModel[] = [];
  origen: IdDescModel[] = [];

  validPtoEmision: string[] = [];
  validTransporte: string[] = [];
  validDestinatario: string[] = [];
  validOrigen: string[] = [];
  validImpresoras: string[] = [];

  filteredPtoEmision: IdDescModel[] = [];
  filteredTransporte: Observable<TransporteBriefModel[]> | undefined;
  filteredDestinatario: Observable<DestinatarioBriefModel[]> | undefined;
  filteredOrigen: Observable<IdDescModel[]> | undefined;

  destinatarioControl = new FormControl<string | DestinatarioBriefModel>('');
  ptoEmisionControl = new FormControl<string | IdDescModel>('');
  transporteControl = new FormControl<string | TransporteBriefModel>('');
  origenControl = new FormControl<string | IdDescModel>('');
  vinLetrasControl = new FormControl<string>('', Validators.pattern("[a-zA-Z0-9 ]*"));
  vinNumerosControl = new FormControl<string>('', Validators.pattern("^[0-9]*$"));
  nroMinControl = new FormControl<number | null>(null, Validators.pattern("^[0-9]*$"));
  nroMaxControl = new FormControl<number | null>(null, Validators.pattern("^[0-9]*$"));
  fecGenDesdeControl = new FormControl<Date | null>(null);
  fecGenHastaControl = new FormControl<Date | null>(null);
  despachoDesdeControl = new FormControl<Date | null>(null);
  despachoHastaControl = new FormControl<Date | null>(null);
  estadoControl = new FormControl<string>('');
  searchCriteria: FormGroup = new FormGroup({
    destino: this.destinatarioControl,
    ptoEmision: this.ptoEmisionControl,
    transporte: this.transporteControl,
    origen: this.origenControl,
    vinLetras: this.vinLetrasControl,
    vinNumeros: this.vinNumerosControl,
    nroMin: this.nroMinControl,
    nroMax: this.nroMaxControl,
    fecGenDesde: this.fecGenDesdeControl,
    fecGenHasta: this.fecGenHastaControl,
    estado: this.estadoControl,
    despachoDesde: this.despachoDesdeControl,
    despachoHasta: this.despachoHastaControl,
  });
  selector: string;

  @ViewChild(MatSort) matSort: MatSort;
  initialSortField = 'nroRemito';
  initialSortDirection: SortDirection = 'desc';

  pageSizes = [10, 15, 20, 25];
  totalElements: number = 0;

  @ViewChild(MatPaginator) matPaginator: MatPaginator;

  @ViewChild('dataTable', {read: ElementRef}) dataTable: ElementRef;

  // @ts-ignore
  @ViewChildren('tableFilter') tableFilters:
    QueryList<FabStringFilterComponent | FabNumberFilterComponent | FabDateFilterComponent>;

  constructor(private remitoService: RemitoVehicleService, private notificationService: NotificationService,
              private securityService: SecurityService, private dialog: MatDialog,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
    this.user = this.securityService.LOGGED_USER.gmin;

    this.impresoraRemito = new ViewVehicle();
    this.impresoraRemito.impresoraField = "";
    let obs: ObservableInput<any>[] = [];
    obs.push(this.remitoService.getDetails("_").pipe(
      map((response) => {
        if (response) {
          // @ts-ignore
          this.createDetailsData = response;
          this.searchDataSource = new MatTableDataSource<RemitoVehicleCreationDetails>(this.createDetailsData);
          for (let i = 0; i < response.ptoEmision.length; i++) {
            this.ptoEmision.push(response.ptoEmision[i]);
            this.validPtoEmision.push(response.ptoEmision[i].id + ' - ' + response.ptoEmision[i].desc);
            this.filteredPtoEmision.push(response.ptoEmision[i]);
          }
          this.validPtoEmision.push('');
          for (let i = 0; i < response.transporte.length; i++) {
            this.transporte.push(response.transporte[i]);
            this.validTransporte.push(response.transporte[i].id + ' - ' + response.transporte[i].desc);
          }
          this.validTransporte.push('');
          this.populateTransporte();
          for (let i = 0; i < response.destinatario.length; i++) {
            this.destinatario.push(response.destinatario[i]);
            this.validDestinatario.push(response.destinatario[i].id + ' - ' + response.destinatario[i].desc + ' - ' + response.destinatario[i].dlCiudad);
          }
          this.validDestinatario.push('');
          this.populateDestinatario();
          for (let i = 0; i < response.origen.length; i++) {
            this.origen.push(response.origen[i]);
            this.validOrigen.push(response.origen[i].id + ' - ' + response.origen[i].desc + ' - ' + response.origen[i].dlCiudad);
          }
          this.validOrigen.push('');
          this.populateOrigen();
          for (let i = 0; i < response.impresoras.length; i++) {
            this.impresoras.push(response.impresoras[i]);
            this.impresoras.forEach((item) => {
              this.impresorasMap.set(item.id + " - " + item.desc, item);
            })
          }
        }
      })));
    concat(...obs).subscribe({
      next: undefined,
      error: undefined
    });
  }

  populateTransporte() {
    this.filteredTransporte = this.transporteControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const transporteValue = typeof value === 'string' ? value : value?.desc;
        return transporteValue ? this.transporteFiltering(transporteValue as string) : this.transporte.slice();
      }),
    );
  }

  populateDestinatario() {
    this.filteredDestinatario = this.destinatarioControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const destinatarioValue = typeof value === 'string' ? value : value?.desc;
        return destinatarioValue ? this.destinatarioFiltering(destinatarioValue as string) : this.destinatario.slice();
      }),
    );
  }

  populateOrigen() {
    this.filteredOrigen = this.origenControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const origenValue = typeof value === 'string' ? value : value?.desc;
        return origenValue ? this.origenFiltering(origenValue as string) : this.origen.slice();
      }),
    );
  }

  private ptoEmisionFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.ptoEmision.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private transporteFiltering(name: string): TransporteBriefModel[] {
    const filterValue = name.toLowerCase();
    return this.transporte.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private destinatarioFiltering(name: string): DestinatarioBriefModel[] {
    const filterValue = name.toLowerCase();
    return this.destinatario.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue) || option.dlCiudad.toLowerCase().includes(filterValue));
  }

  private origenFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.origen.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue) || option.dlCiudad.toLowerCase().includes(filterValue));
  }

  public filteredImpresoras(element: ViewVehicle) {
    return Array.from(this.impresorasMap.keys()).filter((item) => item.toLowerCase().includes(element.impresoraField.toLowerCase()));
  }

  /**
   * Populates the table with search results according to the provided criteria and download if print is true.
   */
  searchAndPrint(print: boolean) {
    this.errorMessage = '';
    if (print) {
      this.isDownloadingExcel = true;
    }
    if (this.isValid()) {
      this.validateDatesSearch();
      if(this.errorMessage != '') {
        this.notificationService.open(this.errorMessage, 'error');
        this.isDownloadingExcel = false;
      } else if (this.searchCriteria.valid) {
        this.viewVehicleSearch = new ViewVehicleSearch();
        this.viewVehicleSearch.nroMin = this.nroMinControl.value;
        this.viewVehicleSearch.nroMax = this.nroMaxControl.value;
        this.viewVehicleSearch.vinLetras = this.vinLetrasControl.value;
        this.viewVehicleSearch.vinNumeros = this.vinNumerosControl.value;
        this.viewVehicleSearch.estado = this.estadoControl.value;
        this.viewVehicleSearch.fecGenDesde = this.selectFecGenDesde;
        this.viewVehicleSearch.fecGenHasta = this.selectFecGenHasta;
        this.viewVehicleSearch.despachoDesde = this.selectDespachoDesde;
        this.viewVehicleSearch.despachoHasta = this.selectDespachoHasta;

        if (this.ptoEmisionControl.value && typeof this.ptoEmisionControl.value === 'string') {
          const value = this.ptoEmisionControl.value.split('-');
          this.viewVehicleSearch.ptoEmision = value[0].trim();
        } else {
          this.viewVehicleSearch.ptoEmision = '';
        }

        if (this.origenControl.value && typeof this.origenControl.value === 'string') {
          const value = this.origenControl.value.split('-');
          this.viewVehicleSearch.origen = value[0].trim();
        } else {
          this.viewVehicleSearch.origen = '';
        }

        if (this.destinatarioControl.value && typeof this.destinatarioControl.value === 'string') {
          const value = this.destinatarioControl.value.split('-');
          this.viewVehicleSearch.destinatario = value[0].trim();
        } else {
          this.viewVehicleSearch.destinatario = '';
        }

        if (this.transporteControl.value && typeof this.transporteControl.value === 'string') {
          const value = this.transporteControl.value.split('-');
          this.viewVehicleSearch.transporte = value[0].trim();
        } else {
          this.viewVehicleSearch.transporte = '';
        }

        this.initialLoadingCompleted = false;
        this.isLoading = true;
        if (this.matSort && this.tableFilters) {
          this.matSort.active = this.initialSortField;
          this.matSort.direction = this.initialSortDirection;
          this.tableFilters.toArray().forEach((x) => x.clearFilter());
          this.matSort.sortChange.emit();
        }

        this.requestPage(print).subscribe(() => {
          this.isLoading = false;
          this.initialLoadingCompleted = true;
        });
      } else {
        // invalid search criteria
        this.notificationService.open("Campos de búsqueda Inválido. Por favor complete los campos requeridos", 'error');
        this.isDownloadingExcel = false;
      }

    } else {
      // no search criteria entered
      this.notificationService.open("Ingrese al menos UN criterio de búsqueda válido para continuar!", 'error');
      this.isDownloadingExcel = false;
    }
  }

  validateDatesSearch() {
    let startDate = new Date;
    let endDate = new Date;
    if (this.selectDespachoDesde != null) {
      startDate.setFullYear(this.selectDespachoDesde.getFullYear());
      startDate.setMonth(this.selectDespachoDesde.getMonth());
      startDate.setDate(this.selectDespachoDesde.getDate());
    }

    if(this.selectDespachoHasta != null) {
      // If there is a start date, end date is required
      this.despachoDesdeControl.setValidators(Validators.required);
      this.despachoDesdeControl.updateValueAndValidity();
      endDate.setFullYear(this.selectDespachoHasta.getFullYear());
      endDate.setMonth(this.selectDespachoHasta.getMonth());
      endDate.setDate(this.selectDespachoHasta.getDate());
    }

    // search criteria is greater than 90 days throw error
    let diff = endDate.getTime() - startDate.getTime();
    if(!(Math.floor(diff / (1000 * 3600 *24)) <= 90)) {
      this.errorMessage = "La búsqueda debe ser menor a 90 días";
    }
  }

  requestPage(print: boolean): Observable<any> {
    return this.remitoService.getPage(
      this.matPaginator?.pageIndex ?? 0,
      this.matPaginator?.pageSize ?? this.pageSizes[0],
      [this.matSort?.active ?? this.initialSortField],
      this.matSort?.direction ?? this.initialSortDirection,
      this.state.filter ?? [],
      this.viewVehicleSearch
    ).pipe(
      map((response) => {
        this.remitos = response.data;
        // @ts-ignore
        if(this.remitos.length > 0 || this.state.filter?.length > 0){
          this.showTabledata = true;
        }
        this.dataSource.data = this.remitos;
        this.totalElements = response.total;
        this.matPaginator.pageIndex = response.page;
        this.matPaginator.pageSize = response.pageSize;
        this.isLoading = false;
        this.showNoResultsMessage();

        if(print){
          this.print();
        }
        return EMPTY;
      }), catchError((error) => {
        this.totalElements = 0;
        this.isLoading = false;
        this.isDownloadingExcel = false;
        return EMPTY;
      })
    );
  }

  showNoResultsMessage(){
    if (!this.showTabledata) {
      this.dataSource.data = [];
      // no results found
      this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');

    }
  }


  scrollTableToTop() {
    this.dataTable.nativeElement.scrollIntoView();
  }

  updatePageState() {
    if (this.initialLoadingCompleted) {
      this.isLoading = true;
      this.requestPage(false).subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  onSortChange() {
    this.matPaginator.pageIndex = 0;
    this.updatePageState();
  }


  getRemitos(searchCriteria: ViewVehicleSearch): Observable<ViewVehicle[]> {
    return this.remitoService.getRemitosBySearchCriteria(searchCriteria);
  }

  setRemitos(response: ViewVehicle[]): void {
    this.remitos = response;
    this.dataSource.data = process(this.remitos, this.state);
  }

  setFecGenDesde(element: any) {
    this.selectFecGenDesde = element;
  }

  setFecGenHasta(element: any) {
    this.selectFecGenHasta = element;
    this.despachoDesdeControl.clearValidators();
    this.despachoDesdeControl.updateValueAndValidity();
  }

  setDespachoDesde(element: any) {
    this.selectDespachoDesde = element;
  }

  setDespachoHasta(element: any) {
    this.selectDespachoHasta = element;
    this.despachoDesdeControl.clearValidators();
    this.despachoDesdeControl.updateValueAndValidity();
  }


  print() { // Call printRemito like remito service
    this.remitoService.downloadExcel(this.viewVehicleSearch).subscribe({
      next: (response) => {
        const newBlob = new Blob([response], {type: 'application/vnd.ms-excel'});
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;

        // @ts-ignore
        const fileName = 'Todos los remitos_' + new Date().toLocaleString().replace('Z', '') + '.xlsx';
        link.download = fileName;
        link.click();
        this.isDownloadingExcel = false;
      },
      error: (error) => {
        this.errors.push(error);
        this.notificationService.open(this.notificationService.getErrorByCode(error.errorCode), 'error')
        this.isDownloadingExcel = false;
      }
    })
  }

  /**
   * On checking a checkbox, Remito is added to selectedRemitos array. The screen-wide impresora selector and email
   * button are activated, and the individual impresora selectors and email buttons are deactivated. If no checkbox
   * is checked, the selectors and buttons are reverted to normal state.
   * @param element
   */
  onChange(element: any) {
    if (element.isChecked) {
      this.selectedRemitos.push(element);
    } else {
      for (var i = 0; i < this.selectedRemitos.length; i++) {
        if (this.selectedRemitos[i].nroRemito === element.nroRemito) {
          this.selectedRemitos.splice(i, 1);
        }
      }
    }

    this.disableEmailAllButton = (this.selectedRemitos.length === 0);
    this.disableEmailButton = this.selectedRemitos.length > 0;
  }

  public clearAllFilters() {
    this.tableFilters.toArray().forEach((x) => x.clearFilter());
    this.getRemitos(this.viewVehicleSearch).subscribe((response) => {
      this.setRemitos(response);
    })
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.filterData();
    //For server side filtering
    this.updatePageState();
  }

  private filterData() {
    this.dataSource.data = process(this.remitos, this.state)
  }

  onNroMaxEntry() {
    if (this.nroMaxControl.dirty && this.nroMaxControl.value != null && this.nroMaxControl.value.toString() != '') {
      this.nroMinControl.setValidators([Validators.required]);
    } else {
      this.nroMinControl.setValidators([]);
    }
    this.nroMinControl.updateValueAndValidity();
  }

  /**
   * Updates the element's impresora to the selected impresora
   * @param {ViewVehicle} element
   */
  changeImpresora(element: ViewVehicle) {
    element.impresorasCode = this.impresorasMap.get(element.impresoraField)?.id ?? null;
  }

  /**
   * Emails all selected Remitos to the selected impresora
   */
  emailAllRemitos() {
    if (this.impresoraRemito.impresorasCode != null && this.impresoraRemito.impresorasCode != ''
      && this.impresoras.filter(item => item.id == this.impresoraRemito.impresorasCode)) {
      this.selectedRemitos.forEach(r => {
        r.impresorasCode = this.impresoraRemito.impresorasCode;
      });
      this.emailRemito(this.selectedRemitos);
      this.selectedRemitos = [];
    } else {
      this.notificationService.open(ErrorCodes.EMAIL_FAILED, "warn")
    }

  }

  /**
   * Emails a single Remito to the selected impresora
   * @param {ViewVehicle} element
   */
  emailSingle(element: ViewVehicle) {
    if (element.impresorasCode != null && element.impresorasCode != ''
      && this.impresoras.filter(item => item.id == element.impresorasCode)) {
      let remitoArray: Array<ViewVehicle> = new Array<ViewVehicle>();
      remitoArray.push(element);
      this.emailRemito(remitoArray);
    } else {
      this.notificationService.open(ErrorCodes.EMAIL_FAILED, "warn");
    }
  }

  /**
   * If the impresoraCode has been set for the provided element(s), then the pdf will be mailed to the given
   * impresoras code
   * @param {ViewVehicle} element
   */
  emailRemito(element: Array<ViewVehicle>) {
    if (element !== null && element[0].impresorasCode) {
      this.isLoading = true;
      this.remitoService.reprintRemitos(element[0].impresorasCode, element).subscribe({
        next: (response) => {
          this.notificationService.open(ErrorCodes.EMAIL_SUCCESS, 'success');
        },
        error: (error) => {
          this.isLoading = false;
          this.errors.push(error);
          this.notificationService.open(ErrorCodes.EMAIL_FAILED, "error")
        },
        complete: () => {
          this.isLoading = false;
          this.disableEmailAllButton = true;
          this.disableEmailButton = false;
          this.disableEmailAllButton = (this.selectedRemitos.length === 0);
          this.disableEmailButton = this.selectedRemitos.length > 0;
          this.impresoraRemito = new ViewVehicle();
          this.impresoraRemito.impresoraField = "";
          this.requestPage(false).subscribe(() => {
            this.isLoading = false;
            this.initialLoadingCompleted = true;
          });
        }
      });
    } else {
      this.notificationService.open(ErrorCodes.EMAIL_FAILED, "warn");
    }
  }

  /**
   * Opens a {@link .PopupCancelVehicleDialogComponent PopupCancelVehicleDialog}. If the cancellation is
   * successful, the row is updated; otherwise, the dialog closes without change.
   * @param     remito      the Remito reference
   * @returns   {ViewVehicle} the Remito updated cancellation data
   */
  cancelarRemito(remito: ViewVehicle): ViewVehicle {
    const dialogRef = this.dialog.open(PopupCancelVehicleDialogComponent, {
      data: {
        remito: remito,
        isReadOnly: false
      }
    });
    return this.afterClosed(dialogRef, remito);
  }

  /**
   * Opens readonly dialog with cancel information
   * @param remito  the Remito reference
   */
  verCancelarObservacion(remito: ViewVehicle) {
    this.dialog.open(PopupCancelVehicleDialogComponent, {
      data: {
        remito: remito,
        isReadOnly: true
      }
    });
  }

  /**
   * After closing the dialog, if the {@link data} is `null`, the results will be ignored. This prevents false
   * error/success from the user either exiting the dialog without submitting or clicking outside the popup window.
   *
   * Next, if `"error"` is returned, then the call to the backend endpoint failed, so an error notification
   * toast is shown to the user.
   *
   * Finally, in a successful submission, the Remito is returned and updated in the View All Remitos table, and
   * a success notification toast is shown to the user.
   * @param {MatDialogRef<PopupCancelRemitoDialogComponent>} dialogRef
   * @param {ViewVehicle} remito
   * @return {ViewVehicle}
   * @private
   */
  afterClosed(dialogRef: MatDialogRef<PopupCancelVehicleDialogComponent>, remito: ViewVehicle): ViewVehicle {
    dialogRef.afterClosed().subscribe(data => {
      if (data != null) {
        if ("error" === data) {
          this.notificationService.open(ErrorCodes.CANCELAR_FALLIDO, 'error');
        } else {
          this.requestPage(false).subscribe(() => {
            this.isLoading = false;
            this.initialLoadingCompleted = true;
          });
          this.notificationService.open(ErrorCodes.CANCELAR_CON_EXITO, 'success');
        }
      }
    })
    return remito;
  }

  /**
   * Returns true if the given Remito has Estado = 'Cancelado'
   * @param {ViewVehicle} remito
   */
  estaCancelado(remito: ViewVehicle) {
    return remito.estadoRemito == 'Cancelado';
  }

  /**
   * Validation check for searching. At least one field must have a value.
   * @return {boolean}
   */
  isValid() {
    return !(
      this.estadoControl.value === "" && this.destinatarioControl.value === "" && this.transporteControl.value === ""
      && this.origenControl.value === "" && this.ptoEmisionControl.value === "" && this.vinLetrasControl.value === ""
      && this.vinNumerosControl.value === "" && this.fecGenDesdeControl.value === null && this.nroMinControl.value === null
      && this.nroMaxControl.value === null && this.despachoDesdeControl.value === null && this.despachoHastaControl.value === null
    );
  }

  handleFileUploadSuccess(res: DispatchVehicleResults) {
    // Determine error code if partial error or fully error
    let errorMessageType: string = res.fullyError ? ErrorCodes.FILE_UPLOAD_NO_SUCCESS : ErrorCodes.FILE_UPLOAD_PROCESSED_PARTIALLY;

    if (res.errorExceedLimit) {
      // if unprocessed vins exceed defined limit
      this.notificationService.open(`${errorMessageType} ${ErrorCodes.FILE_UPLOAD_ERROR_EXCEED_LIMIT}`, 'warn', 0);
    } else if (res.existingDispatchDateList.length == 0 && res.notFoundRemitoList.length == 0 && res.canceledRemitoList.length == 0 && res.futureDispatchList.length == 0) {
      // When success with no error or warning, show success popup
      this.notificationService.open(ErrorCodes.FILE_UPLOAD_PROCESSED_SUCCESS, 'success');
    } else {
      this.openDialog(res);
    }
    this.requestPage(false).subscribe();  // Update table data with new values.
  }

  openDialog(results: DispatchVehicleResults) {
    this.dialog.open(PopupFileUploadMessageDialogComponent, {
      data: {
        type: SCREEN.dispatch,
        results: results,
      }
    });
  }
}
